import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query QueryCOAssetsStatus($projectId: Int!) {
    project(id: $projectId) {
      id
      assetProcessingStatus
    }
  }
`;

export function queryCOAssetsStatus(projectId) {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      projectId,
    },
  }).then(({ data }) => getSingleProp(data).assetProcessingStatus);
}
